// extracted by mini-css-extract-plugin
export default {"tabs_content_sticky_footer":"Element_tabs_content_sticky_footer__Bd8NS","table_inner_form_item":"Element_table_inner_form_item__-ZL5i"};